import "./App.css";
import Rutas from "./routes/Rutas";
import ErrorBoundary from "./componentes/ErrorBoundary";

function App() {
  return (
    <ErrorBoundary>
      <div className="App bg-main-light dark:bg-main-dark min-h-screen transition-all duration-150">
        <Rutas />
      </div>
    </ErrorBoundary>
  );
}

export default App;
